export const SLIDE_CONTENT_POSITION_CENTER = 'center';
export const SLIDE_CONTENT_POSITION_LEFT = 'left';
export const SLIDE_CONTENT_POSITION_RIGHT = 'right';
